import type { FaireProductEntity } from "../../entity_types/product";

export const p_wxd77tt39g: FaireProductEntity = {
  token: "p_wxd77tt39g",
  type: "product",
  name: "Hot Honey Marinara",
  brandToken: "b_ams77vmxsb",
  brandName: "Sauz",
  imageUrl:
    "https://cdn.faire.com/fastly/6a267f45e6cd263b58bc6a22c979b7b1595ff83fcb6873cd2657ee1501292476.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f8ad9474686348af5245f499000fe788ea6921b3c909261424f2a3a28005d8e.png",
    "https://cdn.faire.com/fastly/77fb52b7c3a84479e87bcefec127e2e4670278860ae7752562c88feba06732a1.png",
    "https://cdn.faire.com/fastly/a73a9bfce39453348403dc70d01b528f55e8cc905abf5c1ac7ef9db361b8c091.jpeg",
    "https://cdn.faire.com/fastly/dd7b39a8ec0ce682efabf671b6a1546484ec0683ea6eeca9cdbc47974fc6ed95.png",
  ],
  priceDollars: 6.49,
  description:
    "Hot Honey is a fan favorite for a reason. Little bit of sweet. Whole lotta heat. Treat your tastebuds to the best of both worlds.\n\n✓ SEED OIL FREE\n✓ CALIFORNIA GROWN TOMATOES\n✓ 100% OLIVE OIL\n\nSauz is reimagining what pasta sauce can be. Our bold, original flavors go beyond the basics, made for customers who crave something different and can’t find it in the standard sauce aisle.\n\nWe use high-quality, clean ingredients with real aromatics, california-grown tomatoes, and 100% olive oil. No seed oils & no added sugar. Just rich, balanced flavor with a homemade feel, minus the effort.\n\nEach jar offers something truly unique - flavors that can’t be easily recreated at home. It’s the perfect solution for busy nights when your customers still want something special on the table.\n\nOur sauces fit perfectly into specialty markets, curated pantry collections, and premium gift sets. With eye-catching packaging and repeat-worthy flavor, it’s a standout on the shelf and a favorite in the kitchen.",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:25.219Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
